module.exports = __webpack_public_path__ + "static/media/纸质卡通小车.aa1def20.png";